/**
 * アプリケーション全体で使用する定数
 */

// レイアウト（レスポンシブ）
/** タブレット以下判定のブレークポイント（px）。CSS の max-width: 1024px / min-width: 1025px と一致させる */
export const MOBILE_BREAKPOINT = 1024;

// ライセンス関連
export const LICENSE_LIMIT = 30;

// アニメーション関連
export const MODAL_ANIMATION_DURATION = 200; // ms

// パスワード関連（8文字以上・英数字記号で統一）
export const PASSWORD_MIN_LENGTH = 8;
export const PASSWORD_CHARS = {
  LOWERCASE: 'abcdefghijklmnopqrstuvwxyz',
  UPPERCASE: 'ABCDEFGHIJKLMNOPQRSTUVWXYZ',
  NUMBERS: '0123456789',
  SPECIAL: '!@#$%^&*()_+-=[]{}|;:,.<>?'
};

// 画像関連
export const IMAGE_MAX_SIZE = 5 * 1024 * 1024; // 5MB
export const IMAGE_ALLOWED_TYPES = ['image/jpeg', 'image/jpg', 'image/png', 'image/gif', 'image/webp'];

// その他
export const POSTAL_CODE_AUTO_SEARCH_DELAY = 100; // ms

